import { statusBtnFormatter, dateFormatter, navCollabFormatter } from 'molecules/TableFormatters';

export const supportRequestConfig = (path, push, theme, fnSwitch, isMobile) => [
  {
    dataField: 'title',
    text: 'Title',
    sort: true
  },
  {
    dataField: 'description',
    text: 'Description',
    sort: true
  },
  {
    dataField: 'pit.name',
    text: 'Location',
    sort: true
  },
  {
    dataField: 'dateDeadline',
    text: 'Date',
    formatter: dateFormatter,
    formatExtraData: 'dateDeadline',
    sort: true
  },
  {
    dataField: 'user.displayName',
    text: 'Reported By',
    sort: true
  },
  {
    dataField: 'severity',
    text: 'Severity',
    formatter: statusBtnFormatter,
    formatExtraData: {
      transparent: true,
      theme: theme,
      field: 'severity',
      width: '70',
    },
    headerAttrs: { width: isMobile ? 80 : 100 },
    headerAlign: 'center',
    align: 'center',
    sort: false
  },
  {
    dataField: 'isClosed',
    text: 'Status',
    formatter: statusBtnFormatter,
    formatExtraData: {
      transparent: false,
      theme: theme,
      field: 'isClosed',
      width: '68'
    },
    headerAttrs: { width: isMobile ? 80 : 100 },
    headerAlign: 'center',
    align: 'center',
    sort: true
  },
  {
    dataField: 'action',
    text: 'Action',
    sort: false,
    headerAttrs: { width: 100 },
    headerAlign: 'center',
    align: 'center',
    formatter: navCollabFormatter,
    formatExtraData: {
      path: path,
      nav: push,
      fnSwitch: fnSwitch
    },
    isDummyField: true
  }
]

export const conformityConfig = (path, push, theme, fnSwitch, isMobile) => [
  {
    dataField: 'title',
    text: 'Subject',
    sort: true
  },
  {
    dataField: 'description',
    text: 'Description',
    sort: true
  },
  {
    dataField: 'pit.name',
    text: 'Location',
    sort: true
  },
  {
    dataField: 'dateDeadline',
    text: 'Date',
    formatter: dateFormatter,
    formatExtraData: 'dateDeadline',
    sort: true
  },
  {
    dataField: 'locationTypeLookup.nameDisplay',
    text: 'Type',
    sort: true
  },
  {
    dataField: 'user.displayName',
    text: 'Reported By',
    sort: true
  },
  {
    dataField: 'severity',
    text: 'Severity',
    formatter: statusBtnFormatter,
    formatExtraData: {
      transparent: true,
      theme: theme,
      field: 'severity',
      width: '70',
    },
    headerAttrs: { width: isMobile ? 80 : 100 },
    headerAlign: 'center',
    align: 'center',
    sort: false
  },
  {
    dataField: 'isClosed',
    text: 'Status',
    formatter: statusBtnFormatter,
    formatExtraData: {
      transparent: false,
      theme: theme,
      field: 'isClosed',
      width: '68'
    },
    headerAttrs: { width: isMobile ? 80 : 100 },
    headerAlign: 'center',
    align: 'center',
    sort: true
  },
  {
    dataField: 'action',
    text: 'Action',
    sort: false,
    headerAttrs: { width: 150 },
    headerAlign: 'center',
    align: 'center',
    formatter: navCollabFormatter,
    formatExtraData: {
      path: path,
      nav: push,
      fnSwitch: fnSwitch,
      report: 'report',
    },
    isDummyField: true
  }
]
